<svg xmlns="http://www.w3.org/2000/svg" width="18.576" height="15" viewBox="0 0 18.576 15">
  <path
    d="M13.146,5h7.431V6.781H13.146Zm0,5.5h7.431v1.68H13.146Zm0,5.5h7.431v1.707H13.146ZM2,11.5A6.294,6.294,0,0,0,8.037,18H8.5v2l2.786-3L8.5,14v2.153H8.037A4.7,4.7,0,0,1,3.617,11.5a4.758,4.758,0,0,1,4.42-4.719h3.251V5H8.037A6.294,6.294,0,0,0,2,11.5Z"
    transform="translate(-2 -5)"
    fill="#1c88c8"
  />
</svg>
